import React, { Component, createRef } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { 
  ChevronIcon2
} from './SVGIcons';

// Импорт стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';

class App extends Component {
  constructor(props) {
    super(props);
    this.swiperRefs = {}; // Используем объект вместо массива
    this.state = {
      lightboxOpen: false,
      currentImageIndex: 0,
      currentSlideImages: [],
      currentEventName: '',
      sliderStates: {} // Используем объект для состояний
    };
  }

  // Сохраняем экземпляр Swiper
  setSwiperInstance = (itemIndex, swiper) => {
    this.swiperRefs[itemIndex] = swiper;
    this.handleSlideChange(itemIndex)(swiper);
  }

  // Обновление состояния для конкретного слайдера
  handleSlideChange = (index) => (swiper) => {
    this.setState(prevState => ({
      sliderStates: {
        ...prevState.sliderStates,
        [index]: {
          isBeginning: swiper.isBeginning,
          isEnd: swiper.isEnd
        }
      }
    }));
  }

  // Открыть lightbox с выбранным изображением
  openLightbox = (images, eventName, imageIndex) => {
    this.setState({
      lightboxOpen: true,
      currentImageIndex: imageIndex,
      currentSlideImages: images,
      currentEventName: eventName
    });
    // Блокируем прокрутку страницы
    document.body.style.overflow = 'hidden';
  }

  // Закрыть lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false
    });
    // Возвращаем прокрутку страницы
    document.body.style.overflow = 'auto';
  }

  // Переключение на следующее изображение
  nextImage = () => {
    const { currentImageIndex, currentSlideImages } = this.state;
    
    if (currentImageIndex < currentSlideImages.length - 1) {
      this.setState({
        currentImageIndex: currentImageIndex + 1
      });
    }
  }

  // Переключение на предыдущее изображение
  prevImage = () => {
    const { currentImageIndex } = this.state;
    
    if (currentImageIndex > 0) {
      this.setState({
        currentImageIndex: currentImageIndex - 1
      });
    }
  }

  // Обработка нажатия клавиш
  handleKeyDown = (e) => {
    if (!this.state.lightboxOpen) return;
    
    if (e.key === 'Escape') {
      this.closeLightbox();
    } else if (e.key === 'ArrowRight') {
      this.nextImage();
    } else if (e.key === 'ArrowLeft') {
      this.prevImage();
    }
  }

  componentDidMount() {
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  render() {
    const data = this.props?.data || {};
    const events = data?.events || {};
    const items = events?.items || [];
    const { lightboxOpen, currentImageIndex, currentSlideImages, currentEventName, sliderStates } = this.state;

    return (
      <>
        <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
          <div className='container'>
            <div className='flex justify-center xl:justify-start items-center gap-[12px] text-[14px] xl:text-[16px]'>
              <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4478 5.06976L13.9203 15.2173C13.7403 15.9748 13.0654 16.4998 12.2854 16.4998H2.43034C1.29784 16.4998 0.487853 15.3897 0.825353 14.3022L3.98285 4.16229C4.20035 3.45729 4.85286 2.96973 5.58786 2.96973H14.8128C15.5253 2.96973 16.1179 3.40473 16.3654 4.00473C16.5079 4.32723 16.5378 4.69476 16.4478 5.06976Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10"/>
                  <path d="M12 16.5H15.585C16.5525 16.5 17.31 15.6825 17.2425 14.715L16.5 4.5" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.25977 4.78488L8.03977 1.54492" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12.2852 4.79208L12.9902 1.53711" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.77539 9H11.7754" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.02539 12H11.0254" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em] text-[#032432]/60'>События</div>
              </div>
            </div>
            <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(events?.title)}</h2>
            <div className='mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-center xl:text-start text-black/60'>{Parser(events?.text)}</div>
            
            <div className='grid grid-cols-1 xl:grid-cols-2 gap-[20px] mt-[20px]'>
              {items.map((item, itemIndex) => {
                const sliderState = sliderStates[itemIndex] || { isBeginning: true, isEnd: false };
                
                return (
                  <div key={itemIndex} className='flex items-center gap-[9px] w-full xl:w-auto'>
                    {/* Левая карточка с основной информацией */}
                    <div className='bg-[#F5F7F9] rounded-[15px] p-[5px] flex-1'>
                      <img 
                        src={item.image} 
                        alt={item.name} 
                        width={236} 
                        height={217} 
                        className='w-full h-auto rounded-[15px]'
                      />
                      <div className='px-[15px] mb-[15px] mt-[20px] text-[16px] xl:text-[18px] text-[#032432]'>
                        {item.name} <span className='text-[#032432]/60'>{item.name2}</span>
                      </div>
                      {item.slydes.length > 0 &&
                        <div className='px-[15px] pb-[15px] mt-[15px] xl:hidden'>
                          <div className='flex cursor-pointer items-center justify-center bg-[#009EE3] gap-[9px] text-[12px] h-[40px] rounded-full text-white'
                            onClick={() => this.openLightbox(item.slydes, `${item.name} ${item.name2}`, 0)}
                          >
                            <div>Подробнее</div>
                            <ChevronIcon2 stroke="white" />
                          </div>
                        </div>
                      }
                    </div>

                    {/* Правая часть с слайдером */}
                    <div className='hidden xl:block relative rounded-[15px] overflow-hidden flex-none w-[325px] h-[298px]'>
                      {/* Слайдер */}
                      <Swiper
                        onSwiper={(swiper) => this.setSwiperInstance(itemIndex, swiper)}
                        onSlideChange={this.handleSlideChange(itemIndex)}
                        modules={[Navigation]}
                        spaceBetween={0}
                        slidesPerView={1}
                        className='w-full h-full'
                        allowTouchMove={true}
                      >
                        {item.slydes.map((slide, slideIndex) => (
                          <SwiperSlide key={slideIndex}>
                            <img 
                              src={slide} 
                              alt={`${item.name} ${slideIndex + 1}`} 
                              width={325} 
                              height={298} 
                              className='w-full h-full object-cover cursor-pointer'
                              onClick={() => this.openLightbox(item.slydes, `${item.name} ${item.name2}`, slideIndex)}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      {/* Стрелки навигации */}
                      <button 
                        className={`absolute left-[10px] top-1/2 -translate-y-1/2 w-[38px] h-[38px] cursor-pointer flex items-center justify-center rounded-full transition-opacity duration-300 z-20 ${
                          sliderState.isBeginning 
                            ? 'opacity-30 cursor-not-allowed bg-[rgba(3,36,50,0.3)]' 
                            : 'bg-[rgba(3,36,50,0.73)] hover:bg-[rgba(3,36,50,0.9)]'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const swiper = this.swiperRefs[itemIndex];
                          if (!sliderState.isBeginning && swiper) {
                            swiper.slidePrev();
                          }
                        }}
                        disabled={sliderState.isBeginning}
                        aria-label="Previous slide"
                      >
                        <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.75195 0.25L0.576538 5.75L3.75195 11.25" stroke="white"/>
                        </svg>
                      </button>
                      
                      <button 
                        className={`absolute right-[10px] top-1/2 -translate-y-1/2 w-[38px] h-[38px] cursor-pointer flex items-center justify-center rounded-full transition-opacity duration-300 z-20 ${
                          sliderState.isEnd 
                            ? 'opacity-30 cursor-not-allowed bg-[rgba(3,36,50,0.3)]' 
                            : 'bg-[rgba(3,36,50,0.73)] hover:bg-[rgba(3,36,50,0.9)]'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const swiper = this.swiperRefs[itemIndex];
                          if (!sliderState.isEnd && swiper) {
                            swiper.slideNext();
                          }
                        }}
                        disabled={sliderState.isEnd}
                        aria-label="Next slide"
                      >
                        <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.433594 0.25L3.60901 5.75L0.433594 11.25" stroke="white"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Lightbox для увеличения изображений */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-10 h-10 flex items-center justify-center'
              onClick={this.closeLightbox}
            >
              ×
            </button>

            {/* Кнопка предыдущего изображения */}
            {currentImageIndex > 0 && (
              <button 
                className='absolute left-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-12 h-12 flex items-center justify-center'
                onClick={(e) => {
                  e.stopPropagation();
                  this.prevImage();
                }}
              >
                ‹
              </button>
            )}

            {/* Изображение */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={currentSlideImages[currentImageIndex]} 
                alt={`${currentEventName} - ${currentImageIndex + 1}`}
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Название события и счетчик */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm flex gap-4'>
                <span>{currentEventName}</span>
                <span className='text-gray-300'>{currentImageIndex + 1} / {currentSlideImages.length}</span>
              </div>
            </div>

            {/* Кнопка следующего изображения */}
            {currentImageIndex < currentSlideImages.length - 1 && (
              <button 
                className='absolute right-5 top-1/2 -translate-y-1/2 text-white text-5xl hover:text-gray-300 z-10 w-12 h-12 flex items-center justify-center'
                onClick={(e) => {
                  e.stopPropagation();
                  this.nextImage();
                }}
              >
                ›
              </button>
            )}
          </div>
        )}
      </>
    );
  }
}

export default App;